import { FC } from 'react';
import { IntlShape } from 'react-intl';

const ExchangeDuration: FC<{ className?: string; duration: number | string | number[]; intl: IntlShape }> = ({
    duration,
    className,
    intl,
}) => {
    if (duration && intl) {
        return (
            <div className={className}>
                {intl.formatMessage(
                    {
                        id: 'general.exchangeDuration',
                        defaultMessage: '<b>Aushangdauer:</b> {duration} Tage',
                    },
                    {
                        duration: Array.isArray(duration) ? duration.join(', ') : duration,
                        b: value => <b style={{ fontWeight: 700 }}>{value}</b>,
                    }
                )}
            </div>
        );
    }

    return null;
};

export default ExchangeDuration;
